module.exports = __webpack_public_path__ + "img/buddy_mouth-02.f4f019e2.svg";